import { Component } from '@angular/core';

@Component({
	template: require('./error-has-occured.component.html')
})
export class ErrorHasOccuredComponent{
}
